import { XcoreError } from "./XcoreError";

export class TimeoutError extends XcoreError {
  public name: "TimeoutError" = "TimeoutError" as const;

  constructor(url: string, timeout: number) {
    super(url, `Request to "${url}" timed out (timeout: ${timeout})`);
  }
}
